import { render, staticRenderFns } from "./ThingForm.vue?vue&type=template&id=5f0d3701&"
import script from "./ThingForm.vue?vue&type=script&lang=ts&"
export * from "./ThingForm.vue?vue&type=script&lang=ts&"
import style0 from "./ThingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports